import React from 'react';
import MilaLivingRoomPeople from 'assets/images/mila-living-room-people.jpg';
import MilaLivingRoomPeopleWebp from 'assets/images/mila-living-room-people.jpg?as=webp';
import { checkWebPSupport } from 'supports-webp-sync';
import { useProgressiveImage } from '../../hooks';

const HeroCareers = ({ scrollToJobOpening, scrollToMissionDetail }) => {
  const isWebPSupport = checkWebPSupport();
  const placeholder = isWebPSupport ? MilaLivingRoomPeopleWebp : MilaLivingRoomPeople;
  const loaded = useProgressiveImage(isWebPSupport ? MilaLivingRoomPeopleWebp : MilaLivingRoomPeople);

  return (
    <section className='hero hero--careers'>
      <div className='container'>
        <div className='hero__content'>
          <h1 className='hero__title'>
          Help Make Homes Safer – Work with an Air Purifier Innovator
          </h1>
          <h2 className='hero__subtitle'>Join the Team Behind <br /> Award-Winning Air Purifiers</h2>
          <div className='hero__description'>
            <p>
              We believe everyone deserves to breathe easy. If you’re passionate about clean air too, we’d love
              to have you join our squad. 👊
            </p>
          </div>
          <div className='hero__btn'>
            <button onClick={() => scrollToJobOpening()} type='button' data-id='job-opening' className='btn btn--medium btn--white btn--shadow'>
              Job Openings
            </button>
            <button onClick={() => scrollToMissionDetail()} type='button' data-id='mission-detail' className='btn btn--medium'>Learn More</button>
          </div>
        </div>
        <div className='hero__media'>
          <div className='hero__image' style={{ backgroundImage: `url(${loaded || placeholder})` }} />
        </div>
      </div>
    </section>
  );
};

export default HeroCareers;
